import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    margin-bottom: 1rem;
  }

  > p {
    margin-top: 1rem;
    margin-bottom: 2rem;

    font-weight: bold;
  }

  p.Mui-error {
    margin-top: 0;
  }
`
export const WrapperCabecalho = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;       
  color : black;
  font-weight: 900;
  //align-items: center;
  //justify-content: center;
  > div:not(:first-child) {
    //margin-top: 1.5rem;
  }  
`;

